import { usePageTitle } from "@/lib/usePageTitle";
import FadeIn from "@/components/site/FadeIn";
import { PageHero } from "@/components/site/ui";
import { COMPANY, CREDIT } from "@/data/content";
import { useLocale } from "@/i18n/LocaleContext";
import { DEFAULT_LOCALE } from "@/i18n/locales";

const Block = ({ title, children }) => (
  <div className="mt-8">
    <h2 className="text-2xl font-600 text-brand-dark">{title}</h2>
    <div className="mt-3 text-lg text-muted-foreground leading-relaxed space-y-1">
      {children}
    </div>
  </div>
);

const ExtLink = ({ href, children }) => (
  <a href={href} target="_blank" rel="noopener noreferrer" className="text-brand underline underline-offset-4">
    {children}
  </a>
);

export default function Impressum() {
  usePageTitle("imprint");
  const { t, code } = useLocale();
  const m = t.imprint;
  const a = COMPANY.supervisoryAuthority;

  return (
    <div data-testid="impressum-page">
      <PageHero title={m.title} subtitle={m.subtitle} />
      <section className="bg-white">
        <div className="max-w-3xl mx-auto px-5 md:px-10 py-16 md:py-20">
          <FadeIn>
            {code !== DEFAULT_LOCALE && (
              <p className="rounded-xl bg-brand-light border border-brand/20 p-4 text-base text-ink">
                {t.common.legalNote}
              </p>
            )}

            <Block title={m.company}>
              <p className="font-600 text-ink">{COMPANY.name}</p>
              <p className="ltr">{COMPANY.address.street}</p>
              <p className="ltr">{COMPANY.address.zip} {COMPANY.address.city}</p>
              <p>{m.country}</p>
            </Block>

            <Block title={m.representedBy}>
              <p>{m.managingDirector}: {COMPANY.managingDirector}</p>
            </Block>

            <Block title={m.contact}>
              <p>{m.phone}: <span className="ltr">{COMPANY.phone}</span></p>
              <p>{m.fax}: <span className="ltr">{COMPANY.fax}</span></p>
              <p>{m.email}: {COMPANY.email}</p>
            </Block>

            <Block title={m.register}>
              <p>{m.registerCourt}: {COMPANY.registerCourt}</p>
              <p>{m.registerNumber}: {COMPANY.registerNumber}</p>
            </Block>

            <Block title={m.taxNumber}>
              <p>{COMPANY.taxNumber}</p>
            </Block>

            <Block title={m.licence}>
              <p>{m.licenceText}</p>
              <p>{m.authorityText}</p>
              <p className="text-ink">
                {a.name}
                <br />
                <span className="ltr">{a.street}, {a.zip} {a.city}</span>
                <br />
                <ExtLink href={a.url}>{a.url.replace(/^https?:\/\//, "")}</ExtLink>
              </p>
            </Block>

            <Block title={m.dispute}>
              <p>{m.disputeText}</p>
            </Block>

            <Block title={m.responsible}>
              <p>{COMPANY.managingDirector}</p>
              <p className="ltr">{COMPANY.address.street}, {COMPANY.address.zip} {COMPANY.address.city}</p>
            </Block>

            <Block title={m.credit}>
              <p>
                <ExtLink href={CREDIT.url}>{CREDIT.name}</ExtLink> ({CREDIT.label})
              </p>
            </Block>

            <Block title={m.liabilityContent}>
              <p>{m.liabilityContentText}</p>
            </Block>

            <Block title={m.liabilityLinks}>
              <p>{m.liabilityLinksText}</p>
            </Block>

            <Block title={m.copyright}>
              <p>{m.copyrightText}</p>
            </Block>
          </FadeIn>
        </div>
      </section>
    </div>
  );
}
